import React from "react";
import ReactApexChart from "react-apexcharts";

const ActualValuesDonut = ({ data }) => {
  const series = [
    data.total_actual_project_price,
    data.actual_vat,
    data.total_actual_project_with_vat -
      data.total_actual_project_price -
      data.actual_vat,
  ];

  const labels = ["قيمة الأعمال", "قيمة الضريبة", "الإجمالي (شامل)"];

  const chartOptions = {
    labels: labels,
    colors: ["#3498db", "#f1c40f", "#2ecc71"],
    legend: {
      position: "bottom",
      fontFamily: "Cairo",
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        // const raw = opts.w.config.series[opts.seriesIndex];
        // return `${raw.toLocaleString()} ر.س`;
      },
      style: {
        fontFamily: "Cairo",
        fontSize: "14px",
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val.toLocaleString()} ر.س`,
        title: {
          formatter: (seriesName, { seriesIndex }) => labels[seriesIndex],
        },
      },
      style: {
        fontFamily: "Cairo",
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
  };

  return (
    <div className="p-3">
      <h5
        className="text-center mb-3"
        style={{ fontFamily: "Cairo", fontWeight: "600" }}
      >
        تفصيل الأعمال المنجزة
      </h5>
      <ReactApexChart
        type="donut"
        series={series}
        options={chartOptions}
        width="100%"
      />
    </div>
  );
};

export default ActualValuesDonut;
